import { useState } from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { toast } from 'sonner';
import api from '../../api/axios'; 

export function Promociones() {
  const [loading, setLoading] = useState(false);

  const handleGenerar = async () => {
    setLoading(true);
    try {
      const response = await api.get('/promociones/generar');
      
      if (response.data.success) {
        window.open(response.data.url, '_blank');
        toast.success('PDF generado. Usá Ctrl+P para imprimir.');
      }
    } catch (error) {
      console.error(error);
      toast.error('Error al generar la promoción');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      
      {/* Encabezado Centrado */}
      <div className="mb-8 text-center flex flex-col items-center">
        <h1 className="text-2xl font-bold text-gray-800 flex items-center justify-center gap-2">
          Promociones y Agradecimientos
        </h1>
        <p className="text-gray-500 mt-2 max-w-2xl">
          Generá e imprimí la tarjeta de agradecimiento para incluir dentro de los paquetes. 
          El diseño está optimizado para imprimir 2 unidades por hoja A4.
        </p>
      </div>

      <Card className="p-8 text-center space-y-6">
        
        {/* Tarjeta de instrucciones centrada */}
        <div className="bg-blue-50 text-blue-800 p-6 rounded-lg inline-block mb-4 text-center">
          <p className="font-medium mb-3">Instrucciones de impresión</p>
          <ul className="text-sm space-y-2 list-none">
            <li>El PDF se abrirá en una nueva pestaña.</li>
            <li>Al imprimir, saldrá en la esquina superior izquierda.</li>
            <li>Rotá la hoja A4 y volvé a imprimir para aprovechar el 100% del papel.</li>
          </ul>
        </div>

        <div>
          <Button 
            onClick={handleGenerar} 
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 text-white text-lg py-6 px-8"
          >
            <Printer size={24} className="mr-2" />
            {loading ? 'Generando PDF...' : 'Generar e Imprimir Promoción'}
          </Button>
        </div>

      </Card>
    </div>
  );
}